import React ,{createContext , useContext , useState,useEffect} from "react";
import {useSearchParams} from "react-router-dom";

const DataContext = createContext(null);

const useInitDataContext = () => {
    const [taxId, setTaxId] = useState(null);
    const [tries, setTries] = useState(0);

    const [data,setData] = useState(()=>{
        const storedData = sessionStorage.getItem('data');
        return storedData ? JSON.parse(storedData) : {
            taxId:taxId,
            tries: tries
        };
    });
    useEffect(() => {
        if (sessionStorage.getItem('data') !== data) {
            sessionStorage.setItem('data', JSON.stringify(data));
        }
    }, [data]);

    const clearData = () => {
        sessionStorage.removeItem('data');
    };


    const fetchData = (updatedData) => {
        setData((prevData) => ({
            ...prevData,
            ...updatedData,
        }));
    };

    return {
        data,
        setData,
        clearData,
        fetchData,
    };

};

/**
 * @return {{data: any, setData: (any) => void}}
 */
export const useDataContext = () => {
    const value = useContext(DataContext);
    if (value == null) {
        throw new Error("Please add 'DataContextProvider' element as parent of current component.");
    }
    return {
        data: value.data,
        setData: value.setData,
        clearData: value.clearData,
        fetchData: value.fetchData,
    };
};

export const DataContextProvider = ({children}) => {
    const value = useInitDataContext();
    return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};